(function () {
  'use strict';

  /* Sticky header solidifies on scroll */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    var toggle = header.querySelector('.menu-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* Scroll reveal (AOS-style) */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window && document.body.dataset.animations === 'true') {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Count-up numbers */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, target = parseInt(el.dataset.count, 10), suffix = el.dataset.suffix || '';
        var start = null, dur = 1400;
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.floor(eased * target).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
        cio.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* Cart drawer */
  var drawer = document.getElementById('CartDrawer');
  var fmt = function (cents) {
    var el = document.querySelector('[data-money-format]');
    var f = el ? el.dataset.moneyFormat : '${{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };
  var openDrawer = function () { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } };
  var closeDrawer = function () { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } };

  var renderDrawer = function (cart) {
    if (!drawer) return;
    var body = drawer.querySelector('.cart-drawer__body');
    var total = drawer.querySelector('[data-cart-total]');
    var counts = document.querySelectorAll('[data-cart-count]');
    counts.forEach(function (c) { c.textContent = cart.item_count; });
    if (total) total.textContent = fmt(cart.total_price);
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a class="btn btn--ghost btn--sm" href="/collections/all">Browse the bundle</a></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?.*)?$/, '_160x$1$2') + '" alt="">' : '<div style="width:80px;height:80px;border-radius:12px;background:var(--surface)"></div>';
      return '<div class="cart-item">' + img + '<div style="flex:1"><div class="cart-item__title">' + it.product_title + '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<small class="muted">' + it.variant_title + '</small>' : '') +
        '<div style="margin-top:8px;display:flex;gap:14px;align-items:center"><span class="qty"><button type="button" data-qty="-1" data-key="' + it.key + '">−</button><input value="' + it.quantity + '" readonly><button type="button" data-qty="1" data-key="' + it.key + '">+</button></span>' +
        '<span style="color:var(--text);font-weight:600">' + fmt(it.final_line_price) + '</span></div></div>' +
        '<button type="button" class="cart-item__remove" data-remove="' + it.key + '" aria-label="Remove">✕</button></div>';
    }).join('');
  };

  var updateCart = function (key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderDrawer);
  };

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-drawer]') || e.target.classList.contains('cart-drawer__overlay')) closeDrawer();
      var q = e.target.closest('[data-qty]');
      if (q) { var input = q.parentNode.querySelector('input'); updateCart(q.dataset.key, parseInt(input.value, 10) + parseInt(q.dataset.qty, 10)); }
      var rm = e.target.closest('[data-remove]');
      if (rm) updateCart(rm.dataset.remove, 0);
    });
    document.querySelectorAll('[data-open-drawer]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderDrawer(c); openDrawer(); });
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* AJAX product form */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawer) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (c) { renderDrawer(c); openDrawer(); })
        .catch(function () { form.submit(); })
        .finally(function () { btn.disabled = false; btn.textContent = label; });
    });
  });

  /* Product variant select -> price + id */
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    var form = sel.closest('form');
    var variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    sel.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === sel.value; });
      if (!v) return;
      form.querySelector('input[name="id"]').value = v.id;
      var price = form.closest('.product') && form.closest('.product').querySelector('[data-price]');
      if (price) price.textContent = fmt(v.price);
      var btn = form.querySelector('[type="submit"]');
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.label : 'Sold out';
    });
  });

  /* Product thumbs */
  document.querySelectorAll('.product__thumbs img').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (main) main.src = t.dataset.full;
      document.querySelectorAll('.product__thumbs img').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
})();
